/* Is this station running an older console than the one that is live?
 *
 * The build writes its id into the bundle and into version.json beside it (see
 * vite.config.js). A station compares the two. Anything it cannot read is
 * "not behind": a tablet with no internet, a half-deployed folder, or a dev
 * server must never nag the desk to reload into a page that may not load.
 */
export function isBehind(running, live) {
  if (typeof running !== 'string' || typeof live !== 'string') return false;
  if (!running || !live || running === 'dev') return false;
  return running !== live.trim();
}

// The build id out of version.json's body, or null.
export function liveBuildFrom(body) {
  if (!body || typeof body !== 'object') return null;
  return typeof body.build === 'string' && body.build ? body.build : null;
}
